import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, SocialSection,
    AboutSection, EducationSection, ReferencesSection,
} from './PdfSections';

const HEADING = '#322480';

const styles = StyleSheet.create({
    page: { padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    bar1: { backgroundColor: '#0BD7E6', height: 8, width: '100%' },
    bar2: { backgroundColor: '#4284FF', height: 8, width: '80%' },
    bar3: { backgroundColor: '#130080', height: 8, width: '50%' },
    body: { padding: 30 },
    name: { fontSize: 20, fontWeight: 'bold' },
    title: { fontSize: 12, marginBottom: 10 },
    row: { flexDirection: 'row' },
    col: { width: '50%', paddingRight: 15 },
});

function Template4Pdf(props) {
    const {
        name, about, email, address, phone, title,
        softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.bar1} /><View style={styles.bar2} /><View style={styles.bar3} />
                <View style={styles.body}>
                    <Text style={styles.name}>{name}</Text>
                    <Text style={styles.title}>{title}</Text>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <AboutSection about={about} headingColor={HEADING} />
                            <ReferencesSection referenceData={referenceData} headingColor={HEADING} />
                        </View>
                        <View style={styles.col}>
                            <ContactSection email={email} phone={phone} address={address} headingColor={HEADING} />
                            {/* SoftSkillsComponent has no dedicated badge-list helper title match — reuse generic */}
                            <EducationSection educationData={educationData} headingColor={HEADING} />
                        </View>
                    </View>
                    <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} headingColor={HEADING} />
                </View>
                <View style={styles.bar3} /><View style={styles.bar2} /><View style={styles.bar1} />
            </Page>
        </Document>
    );
}

export default Template4Pdf;